import { styled } from "@mui/material";

export const HeaderContainer = styled("header")`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  position: sticky;
  top: 0;
  z-index: 9999;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Logo = styled("img")`
  cursor: pointer;
`;

export const Nav = styled("nav")<{ isOpen: boolean }>`
  display: flex;
  gap: 1rem;

  @media (max-width: 1268px) {
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 999;
    background: #fff;
    padding: 1rem;
    display: ${(props: { isOpen: boolean }) =>
      props.isOpen ? "flex" : "none"};
  }
`;

export const NavItem = styled("button")`
  background: none;
  border: none;
  text-decoration: none;
  color: #2a2e3c;
  font-size: 14px;
  font-weight: bold;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    text-decoration: underline;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 1310px) {
    padding: 0.2rem;
  }
`;

export const BurgerMenu = styled("button")`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;

  @media (max-width: 1268px) {
    display: block;
  }
`;

export const RightContainer = styled("div")`
  gap: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const LeftContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 0;
  }
`;
